import React from 'react'
import { format, parseISO } from 'date-fns'
import { boolean } from 'yup'

interface DateDisplayProps {
  label: string
  value: string
  isDate?: boolean

  isInput?: boolean
  isInCollapse?: boolean
  onChange?: (value: string) => void
}

const DataInput: React.FC<DateDisplayProps> = ({
  label,
  value,
  isDate = false,
  isInput = false,
  isInCollapse = false,
  onChange,
}) => {
  const formatDate = (isoString: string) => {
    try {
      return format(parseISO(isoString), "MMMM d, yyyy 'at' h:mm a")
    } catch {
      return 'Invalid date'
    }
  }

  return (
    <>
      {isInput ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '16px',
            width: '100%',
          }}
        >
          <label
            style={{
              width: '17%',
              // marginRight: "12px",
              fontWeight: '500',
              fontSize: '16px',
              fontFamily: 'Gilroy-Regular',
              whiteSpace: 'nowrap',
              // border: "1px solid #ccc",
              padding: '8px 12px',
            }}
          >
            {label}
          </label>
          <input
            type="text"
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            // readOnly={!onChange}
            style={{
              padding: '8px 12px',
              border: '0px solid #ccc',
              borderRadius: '6px',
              backgroundColor: isInCollapse ? '#F6F6F6' : '#fff',
              fontFamily: 'Gilroy-Regular',
              flex: 1,
              minHeight: '20px',
              fontSize: '16px',
            }}
          />
        </div>
      ) : (
        <div style={{ marginBottom: '16px' }}>
          <label
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '500',
              fontSize: '16px',
              fontFamily: 'Gilroy-Regular',
            }}
          >
            {label}
          </label>

          <div
            style={{
              padding: '16px 24px',
              border: '1px solid #ddd',
              borderRadius: '8px',
              backgroundColor: '#D9D9D9',
              minHeight: '20px',
              fontFamily: 'Gilroy-Regular',
              fontSize: '16px',
            }}
          >
            {isDate ? formatDate(value) : value}
          </div>
        </div>
      )}
    </>
  )
}

export default DataInput
